import { connect } from "react-redux";

import { hideModal } from "../../../../actions/modals";
import { showToast } from "../../../../actions/toasts";
import { showModal } from "../../../../actions/modals";
import { putNormalizedEntities } from "../../../../helpers";
import modalTypes from "../../../../constants/modalTypes";

import LibraryPhotoAdjustmentModalContainer from "./LibraryPhotoAdjustmentModalContainer";

function getCalculatedAspectRatio(aspectRatioString) {
    const split = aspectRatioString.split(":");

    return split[0] / split[1];
}

const mapStateToProps = (state, props) => {
    const {
        entities: { ceremonies, crematories, photos }
    } = state;

    const { ceremonyId, photoId } = props;

    const ceremony = ceremonies.byId[ceremonyId].item;
    const crematory = crematories.byId[ceremony.crematoryId].item;
    const photo = photos.byId[photoId];

    return {
        aspectRatio: getCalculatedAspectRatio(crematory.aspectRatio),
        ceremony,
        crematory,
        isVisible: true,
        photo
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        hideModal: () => {
            dispatch(hideModal());
        },
        showToast: options => dispatch(showToast(options)),
        updateStoreEntities: entities =>
            putNormalizedEntities(dispatch, entities),
        showImageCropModal: () => {
            dispatch(hideModal());
            dispatch(
                showModal({
                    type: modalTypes.LIBRARY_IMAGE_CROP,
                    props: {
                        ceremonyId: parseInt(props.ceremonyId),
                        photoId: props.photoId
                    }
                })
            );
        },
        showImageRotateModal: (photoId, photo) => {
            dispatch(hideModal());
            dispatch(
                showModal({
                    type: modalTypes.LIBRARY_IMAGE_ROTATE,
                    props: {
                        ceremonyId: parseInt(props.ceremonyId),
                        photoId: props.photoId
                    }
                })
            );
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LibraryPhotoAdjustmentModalContainer);
